import React from "react";

const NotificationsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={22}
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.93816 7C1.93816 5.14348 2.67566 3.36301 3.98842 2.05025C5.30117 0.737498 7.08165 0 8.93816 0C10.7947 0 12.5752 0.737498 13.8879 2.05025C15.2007 3.36301 15.9382 5.14348 15.9382 7V10.764L17.7602 14.408C17.844 14.5757 17.8836 14.7621 17.8752 14.9494C17.8668 15.1368 17.8106 15.3188 17.712 15.4783C17.6134 15.6379 17.4757 15.7695 17.3119 15.8608C17.1481 15.9521 16.9637 16 16.7762 16H12.8122C12.5897 16.8582 12.0886 17.6183 11.3874 18.1609C10.6863 18.7035 9.82476 18.9979 8.93816 18.9979C8.05157 18.9979 7.19007 18.7035 6.4889 18.1609C5.78773 17.6183 5.2866 16.8582 5.06416 16H1.10016C0.912641 16 0.728224 15.9521 0.56443 15.8608C0.400635 15.7695 0.262901 15.6379 0.164308 15.4783C0.0657151 15.3188 0.00953771 15.1368 0.00111129 14.9494C-0.00731514 14.7621 0.0322892 14.5757 0.116163 14.408L1.93816 10.764V7ZM7.20616 16C7.38171 16.304 7.63418 16.5565 7.93821 16.732C8.24223 16.9075 8.58711 16.9999 8.93816 16.9999C9.28922 16.9999 9.63409 16.9075 9.93812 16.732C10.2421 16.5565 10.4946 16.304 10.6702 16H7.20616ZM8.93816 2C7.61208 2 6.34031 2.52678 5.40263 3.46447C4.46495 4.40215 3.93816 5.67392 3.93816 7V10.764C3.93814 11.0743 3.8659 11.3804 3.72716 11.658L2.55716 14H15.3202L14.1502 11.658C14.0111 11.3805 13.9385 11.0744 13.9382 10.764V7C13.9382 5.67392 13.4114 4.40215 12.4737 3.46447C11.536 2.52678 10.2642 2 8.93816 2Z"
      fill="currentColor"
    />
  </svg>
);

export default NotificationsIcon;
